import React, { useEffect } from 'react';
import type { SnackbarProps } from '@makemydeal/dr-ui-bricks-types';
import { SnackbarCloseButton, StyledSnackbar, Content, StyledIcon, borderColorByType } from './snackbar.style';
import Icon from '../Icon/Icon';
import { InfoIcon } from '../Icons/InfoIcon';

const Snackbar: React.FC<SnackbarProps> = ({
    open,
    message,
    type = 'info',
    autoHideDuration = 3000,
    anchorOrigin = { vertical: 'top', horizontal: 'right' },
    onClose
}) => {
    useEffect(() => {
        if (!open) return undefined;

        const timer = setTimeout(() => {
            onClose();
        }, autoHideDuration);

        return () => clearTimeout(timer);
    }, [open, autoHideDuration, onClose]);

    if (!open) return null;

    return (
        <StyledSnackbar anchor={anchorOrigin} isVisible={open} type={type}>
            <StyledIcon>
                <Icon svg={<InfoIcon fill={borderColorByType()[type]} />} />
            </StyledIcon>
            <Content>{message}</Content>
            <SnackbarCloseButton
                onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                &times;
            </SnackbarCloseButton>
        </StyledSnackbar>
    );
};
export default Snackbar;
